import ReactApexChart from "react-apexcharts";
import EmptyState from "../common/EmptyState";

const SERIES_CONFIG = [
  { key: "answeredCalls", name: "Answered", color: "#0FA9C0" },
  { key: "inboundCalls", name: "Inbound", color: "#5BA0E6" },
  { key: "outboundCalls", name: "Outbound", color: "#F4B860" },
  { key: "droppedCalls", name: "Dropped", color: "#9AA4B2" },
];

export default function PerformanceCard({ chartData = [] }) {
  const categories = chartData.map((item) => item.label || "--");
  const series = SERIES_CONFIG.map((config) => ({
    name: config.name,
    data: chartData.map((item) => Number(item[config.key] || 0)),
  }));
  const hasData = series.some((item) => item.data.some((value) => Number(value || 0) > 0));

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: "inherit",
    },
    colors: SERIES_CONFIG.map((config) => config.color),
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.4,
        opacityFrom: 0.22,
        opacityTo: 0.04,
        stops: [0, 90, 100],
      },
    },
    grid: {
      borderColor: "#E6ECF3",
      strokeDashArray: 4,
      padding: { left: 8, right: 12 },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      markers: { radius: 12 },
      itemMargin: { horizontal: 10, vertical: 4 },
    },
    xaxis: {
      categories,
      labels: {
        style: { colors: "#7A8596", fontSize: "12px" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      decimalsInFloat: 0,
      forceNiceScale: true,
      labels: {
        formatter: (value) => String(Math.round(value)),
        style: { colors: "#7A8596", fontSize: "12px" },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (value) => `${Math.round(value)} calls`,
      },
    },
  };

  return (
    <section className="performance-card">
      <div className="performance-card-head">
        <div>
          <div className="performance-card-title">Call Performance</div>
          <p className="performance-card-subtitle">Answered, inbound, outbound, and dropped calls</p>
        </div>
      </div>

      <div className="performance-chart">
        {hasData ? (
          <ReactApexChart options={options} series={series} type="area" height={310} />
        ) : (
          <EmptyState
            title="No performance data"
            subtitle="Calls matching the selected filters will appear here."
          />
        )}
      </div>
    </section>
  );
}
